var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[_c('SideMenu',{attrs:{"size":_vm.size},on:{"on-shared-group":_vm.onSharedGroup,"change-modal-view":_vm.changeModalView,"on-logout":_vm.onLogout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }